import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Divider from 'components/Luxkit/Divider'
import TextLoadingBox from 'components/Luxkit/Typography/TextLoadingBox'
import React from 'react'

function CarHireImportantInformationSkeleton() {
  return (
    <VerticalSpacer gap={16}>
      <TextLoadingBox typography="body-medium" width="100%" />
      <TextLoadingBox typography="body-small" width="100%" lines={3} />
      <Divider kind="primary"/>
    </VerticalSpacer>
  )
}

export default CarHireImportantInformationSkeleton
